import React, { useEffect, useState } from 'react';
import { SpeakComappModelItem } from '../models/superbit-api-models';
import moment from 'moment';
import { Dropdown, MenuProps } from 'antd';

type Props = {
    callItemDetails: SpeakComappModelItem;
    config: any;
};

const ClientCallItem =(props: Props)=> {
    const [callItem, setCallItem] = useState<SpeakComappModelItem>(new SpeakComappModelItem());
    const [path, setPath] = useState<string>('');
    const [apiUrl, setApiUrl] = useState<string>('');
    const [serverPath, setServerPath] = useState<string>('');
    const [clientItems, setClientItems] = useState<MenuProps['items']>([]);

    
    const onMenuClicked = (type: string)=>{}

    const getDownloadLink = () => {
        let url = '';
        
        if (callItem.path && callItem.path.length > 0 && callItem.path !== '/') {
            url = apiUrl + serverPath;
            url += encodeURI(callItem.path);
            // https://api.superbit.co.il/api/account/userGetCall?Url=
        }
        return url;
    }

    useEffect(()=>{
        setClientItems([
            {
                key: '1',
                label: (
                    <li className="pointer rtl"
                        onClick={()=>{onMenuClicked('edit')}}
                    >
                        הורד קובץ
                    </li>
                ),
                disabled: path === ''
            }
        ])
    },[path])

    useEffect(()=>{
        const item = props.callItemDetails;
        if (item) {
            if (item.src && item.src !== '' && item.src !== '/') {
                item.src = serverPath + '' + item.src;
            }
        }
        setCallItem(item)
    }, [props])

    useEffect(()=>{
        console.log('useEffect callItem');
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        const callServerPath = localStorage.getItem('callDownloadPath');
        if (serverPath == '' && callServerPath) {
            setServerPath(callServerPath);
        }
        console.log('ClientCallItem -> init urls')
        if (callItem.path && callItem.path.length > 0 && callItem.path !== '/') {
            const parts = callItem.path.split('/');
            setPath(parts[parts.length - 1]);
            // setDownloadUrl(serverPath);
        }

    },[callItem])

    useEffect(()=>{
        console.log('useEffect []')
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        const callServerPath = localStorage.getItem('callDownloadPath');
        if (serverPath == '' && callServerPath) {
            setServerPath(serverPath);
        }
        console.log('ClientCallItem -> init urls')
    },[])

    
    const downloadDocument = (docUrl: string | undefined) => {
        if(apiUrl !== '' && docUrl) {
            const fileUrl = `${apiUrl}${docUrl}`;
            console.log('downloadDocument', fileUrl );
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target='_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const emptyFunc = () => {}
    
    return (
        <Dropdown menu={{ items: clientItems }} trigger={['contextMenu']}>
            <div className="data-card call-details-row call-item flex-space-between">
                <div className="data-card-body flex-space-between">
                    <div className="cell date">
                        <div className="description cell-value">
                            <div>
                            {moment(callItem.start_stamp).format('DD-MM-YYYY')}
                            </div>
                            <div>
                            {moment(callItem.start_stamp).format('HH:mm')}
                            </div>
                        </div>
                    </div>
                    <div className="cell source">
                        <div className="description cell-value">
                            {callItem.src }
                        </div>
                    </div>
                    <div className="cell target">
                        <div className="description cell-value">
                            {callItem.dst }
                        </div>
                    </div>
                    <div className="cell call-length">
                        <div className="description cell-value">
                            {callItem.billsec }
                        </div>
                    </div>
                    <div className="cell link">
                        <div className="description cell-value">
                            <a href={getDownloadLink()} target='_blank'>
                            {path}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Dropdown>
    )
}

export default ClientCallItem;